<template>
  <v-card class="elevation-12">
    <v-toolbar dark color="primary">
      <v-toolbar-title>Esqueceu a senha?</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-form>
        <v-text-field v-model="email" name="email" label="E-mail" type="text"></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="submit" color="primary">Obter nova senha</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'ForgotPassword',

  data: () => ({
    logo: require('@/assets/logo.png'),
    email: ''
  }),

  props: {
    source: String
  },

  methods: {
    submit () {
      this.axios.post('/users/passwords', { email: this.email })
        .then(() => this.submitSuccessful())
        .catch(error => this.submitFailed(error))
    },
    submitSuccessful () {
      this.$swal('E-mail enviado!', 'Para recuperar sua senha, siga as instruções enviadas no e-mail', 'success')
    },
    submitFailed (error) {
      this.$swal('Ops!', 'Não foi possível enviar o e-mail.', 'error')
      console.error(error)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
